import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { DEFAULT_METABASE_SETTINGS, type MetabaseSettings } from "@/lib/types";

/** Wird nach dem Speichern in den Einstellungen gefeuert, damit die Sidebar sofort nachzieht. */
export const METABASE_SETTINGS_EVENT = "leif:metabase-settings-changed";

export function useMetabaseSettings(): MetabaseSettings {
  const [settings, setSettings] = useState<MetabaseSettings>(DEFAULT_METABASE_SETTINGS);

  const reload = useCallback(() => {
    api
      .get<MetabaseSettings>("/api/settings/metabase")
      .then(setSettings)
      .catch(() => setSettings(DEFAULT_METABASE_SETTINGS));
  }, []);

  useEffect(() => {
    reload();
    window.addEventListener(METABASE_SETTINGS_EVENT, reload);
    return () => window.removeEventListener(METABASE_SETTINGS_EVENT, reload);
  }, [reload]);

  return settings;
}
